import { render, staticRenderFns } from "./ExcellentReport.vue?vue&type=template&id=c80eb3fe&scoped=true"
import script from "./ExcellentReport.vue?vue&type=script&lang=js"
export * from "./ExcellentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80eb3fe",
  null
  
)

export default component.exports